import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';
import moment from "moment-timezone";

export async function getDiemDanhMuon(payload: {
  page?: number;
  limit?: number;
  cond?: any;
  donViId?: string;
  ngay?: number;
  thang?: number;
  nam?: number;
}) {
  const { page, limit, donViId, ngay, thang, nam, cond } = payload;
  let cond2:any
  console.log('cond2', cond)
  if(cond["con.hoTen"]) {
    cond2= {
      regex: cond["con.hoTen"]["$regex"],
      options: cond["con.hoTen"]["$options"]
    }
    delete cond["con.hoTen"]
  }
  return axios.get(
    `${ip3}/diem-danh/trong-muon/don-vi/${donViId}/nam/${nam}/thang/${thang}/ngay/${ngay}`,
    {
      params: {
        page,
        limit,
        cond1: {
          ...cond
        },
        cond2: {
          ...cond2
        }
      },
    },
  );
}
export async function updateDiemDanhMuon(payload: { id: string; data: any }) {
  const { id, data } = payload;
  return axios.put(`${ip3}/diem-danh/diem-danh-muon/${id}`, data);
}
